<template>
  <div>
    <b-table :fields="stageAverageFields" :items="stageAverages" small striped bordered></b-table>
    <bar-chart :chart-data="stageAverageData"></bar-chart>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stageAverageFields: [
        { key: "name", label: "Stage" },
        { key: "averageTimeFromLastStage", label: "Avg days since last stage" },
        {
          key: "averageTimeFromContractCreation",
          label: "Avg days since contract created"
        }
      ],
      colors: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)"
      ],
      borderColors: [
        "rgba(255,99,132,1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)"
      ]
    };
  },

  props: {
    stageAverages: {
      type: Array,
      required: true
    }
  },

  computed: {
    stageAverageData: function() {
      var that = this;

      var formattedData = {
        labels: [],
        datasets: [
          {
            label: "Avg days since last stage",
            backgroundColor: [],
            borderColor: [],
            borderWidth: 1,
            data: []
          }
        ]
      };

      var colorIndex = 0;
      _.forEach(this.stageAverages, function(stageAverage) {
        formattedData.labels.push(stageAverage.name);
        formattedData.datasets[0].data.push(
          stageAverage.averageTimeFromLastStage
        );
        formattedData.datasets[0].backgroundColor.push(that.colors[colorIndex]);
        formattedData.datasets[0].borderColor.push(
          that.borderColors[colorIndex]
        );
        if (colorIndex < that.colors.length - 1) {
          colorIndex++;
        } else {
          colorIndex = 0;
        }
      });

      return formattedData;
    }
  }
};
</script>

<style scoped>
</style>
